<template>
  <div>
    <drawer :isActive="showDrawer" @closed="showDrawer = false"></drawer>
    <div
      class="fixed-banner"
      style="background-color:whitesmoke"
      v-if="!isGift && currentStoreDoc"
    >
      <div class="container-fluid mobile-banner" :style="mobileStyles.TitleBar">
        <div class="row align-items-center">
          <div
            class="col-2 shop-title"
            v-if="viewConfig.LogIn"
          >
            <a class="text-white" @click.prevent="hClick">
              <span class="material-icons md-36">menu</span>
            </a>
          </div>
          <div class="col-2" v-if="currentStoreDoc.Logo && showLogo">
            <img
              :src="currentStoreDoc.Logo"
              class="logo"
              alt="logo"
              @error="showLogoError"
            />
          </div>
          <div
            class="d-flex align-items-center"
            :class="currentStoreDoc.Logo && showLogo ? 'col-5' : 'col-7'"
            style="height:52px"
            @click="navigateToHome()"
          >
            <span class="title-text" v-show="currentStoreDoc.StoreTitle">{{
              currentStoreDoc.StoreTitle
            }}</span>
            <span
              class="title-text"
              v-show="!currentStoreDoc.StoreTitle && !isGift"
              >{{ currentStoreDoc.Name }}</span
            >
          </div>
          <div
            :class="viewConfig.LogIn ? 'col-3' : 'col-4'"
          >
            <ul class="nav float-right">
              <li
                v-if="
                  getUsedLifeStyles.allergies.length > 0 ||
                    getUsedLifeStyles.intolerances.length > 0 ||
                    getUsedLifeStyles.preferences.length > 0
                "
                class="dietary"
              >
                <div
                  class="polygon"
                  v-show="showDietary"
                  :style="mobileStyles.TitleBarBorderColor"
                ></div>
                <a
                  id="dietaryNavbarDropdown"
                  v-if="!isGift"
                  href="#"
                  role="button"
                  @click.prevent="openDietary()"
                >
                  <span>
                    <i class="fa fa-1-5x sliders-abacus"></i>
                  </span>
                </a>
                <div
                  class="dietary-container"
                  v-show="showDietary"
                  :style="mobileStyles.TitleBar"
                >
                  <div>
                    <div
                      v-for="allergy in getUsedLifeStyles.allergies"
                      :key="'allergy' + allergy.Id"
                    >
                      <label class="checkbox-label d-flex">
                        <div
                          class="dietary-icon"
                          :style="getIconStyle(allergy)"
                        ></div>
                        <input
                          type="checkbox"
                          :checked="allergy.isSelected"
                          @click="allergyChecked(allergy)"
                        />
                        <span
                          class="checkbox-checkmark right"
                          :style="getStyle()"
                        ></span>
                        {{ allergy.Name }}
                      </label>
                    </div>
                    <div
                      v-for="intolerance in getUsedLifeStyles.intolerances"
                      :key="'intolerance' + intolerance.Id"
                    >
                      <label class="checkbox-label d-flex">
                        <div
                          class="dietary-icon"
                          :style="getIconStyle(intolerance)"
                        ></div>
                        <input
                          type="checkbox"
                          :checked="intolerance.isSelected"
                          @click="intoleranceChecked(intolerance)"
                        />
                        <span
                          class="checkbox-checkmark right"
                          :style="getStyle()"
                        ></span>
                        {{ intolerance.Name }}
                      </label>
                    </div>
                    <div
                      v-for="preference in getUsedLifeStyles.preferences"
                      :key="'preference' + preference.Id"
                    >
                      <label class="checkbox-label d-flex">
                        <div
                          class="dietary-icon"
                          :style="getIconStyle(preference)"
                        ></div>
                        <input
                          type="checkbox"
                          :checked="preference.isSelected"
                          @click="preferencesChecked(preference)"
                        />
                        <span
                          class="checkbox-checkmark right"
                          :style="getStyle()"
                        ></span>
                        {{ preference.Name }}
                      </label>
                    </div>
                  </div>
                  <a class="clear-all" @click="clearAllDietarySelection()">{{
                    $t("message.ClearAll")
                  }}</a>
                </div>
              </li>
              <li class="dropdown language">
                <a
                  id="navbarDropdown"
                  class="dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="text-white">
                    <i class="fa fa-1-5x fa-globe"></i>
                  </span>
                </a>
                <div
                  class="dropdown-menu lg-dropdown-menu"
                  style="margin-top:30px"
                  :style="mobileStyles.TitleBar"
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    v-for="(lang, index) in getAvailableLanguages"
                    :key="index"
                    href="javascript:void(0)"
                    class="dropdown-item text-white pl-0"
                    @click="setLocale(lang.locale)"
                    >{{ lang.name }}</a
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        v-if="!showPopular && OrdersData.length > 0 && ReorderStatus && !isGift"
        class="container-fluid"
        @touchstart="taphandler"
      >
        <ReorderSlide :orders="OrdersData" @SkipPressed="hideReorder()" />
      </div>
      <confirmationModal></confirmationModal>
      <div
        class="container-fluid category-naviagtion"
        :style="mobileStyles.nav"
        v-if="!isGift"
      >
        <div class="row search-product">
          <div class="search-box col-12">
            <i class="fa fa-search" aria-hidden="true"></i>
            <input
              type="text"
              v-model="filterText"
              class="form-input"
              :placeholder="getSearchProductsPlaceholder"
              @input="scrollToHere()"
            />
          </div>
        </div>
        <div class="row">
          <ul class="store-menu-mobile">
            <li
              v-for="category in categories"
              :key="category.ID"
              :style="itemStyle(category)"
              @click="updateSelected(category)"
            >
              <a
                :style="mobileStyles.navText"
                :href="'#section-' + category.ID"
              >{{ category.Name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <footer
      class="full-extras-footer"
      v-show="
        (isGift === true && giftCartTotalQuantity > 0) ||
          (cartTotalQuantity > 0 && isGift === false)
      "
    >
      <router-link
        v-if="isGift"
        :to="{
          name: 'giftshoppingcartmobile',
          params: { storeid: storeId, storename: $route.params.storename },
        }"
      >
        <button type="submit" class="btn btn-primary">
          <span class="view-cart">
            <span class="material-icons md-36">shopping_cart</span>
            {{ $t("message.viewCart") }} ({{ giftCartTotalQuantity }})
          </span>
          <span>{{ cartTotal | formatMoney(currencySign) }}</span>
        </button>
      </router-link>

      <button
        v-else-if="!isDigitalDisplay"
        type="submit"
        @click="navigateToShoppingCart()"
        class="btn btn-primary"
        :style="mobileStyles.btn"
      >
        <span class="view-cart">
          <span class="material-icons">shopping_cart</span>
          {{ $t("message.viewCart") }} ({{ cartTotalQuantity }})
        </span>
        <span class="total">{{ cartTotal | formatMoney(currencySign) }}</span>
      </button>
    </footer>
  </div>
</template>
<script>
import $ from "jquery";
import { $$ } from "./../../../sharedscripts/OO_jquery";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Validator } from "vee-validate";
import en from "vee-validate/dist/locale/en";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import drawer from "../../shared/drawer";
import ReorderSlide from "../../shared/ReorderSlide";
import confirmationModal from "../../confirmationModal.vue";

export default {
  name: "ShopHeader",
  components: {
    drawer,
    ReorderSlide,
    confirmationModal,
  },
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
    storeId: {
      type: String,
      default: "",
    },
    categories: {
      type: Array,
      default: () => [],
    },
    showSearchBox: {
      type: Boolean,
      default: false,
    },
    showPopular: Boolean,
  },
  data() {
    return {
      ReorderStatus: true,
      store: Object,
      activeMenu: 0,
      once: true,
      showDrawer: false,
      selected: null,
      showLogo: true,
      showDietary: false,
      filterText: "",
      mylatesttap: null,
      OrdersData: [],
    };
  },
  watch: {
    categories() {
      this.$nextTick(() => {
        this.doScroll();
      });
    },
    currentStoreDoc() {
      if(this.currentStoreDoc)
      {
        let odata = localStorage.getItem(this.currentStoreDoc.ID+"-OrdersDatas");
        this.OrdersData = odata != null ? JSON.parse(odata):[];
        if((!this.OrdersData.length > 0) || !this.viewConfig.LogIn)
          this.hideReorder();
      }
    }
  },
  computed: {
    ...mapGetters([
      "getMobileEmbededReturnUrl",
      "getAvailableLanguages",
      "currentStoreDoc",
      "user",
      "cartValue",
      "cartItems",
      "giftCartItems",
      "giftCartValue",
      "isGift",
      "cartTotalQuantity",
      "giftCartTotalQuantity",
      "viewConfig",
      "mobileStyles",
      "storeSelectionAtCheckoutMode",
      "getUsedLifeStyles",
      "getDietarySelection",
      "isDigitalDisplay",
      "currencySign",
    ]),
    cartTotal() {
      return this.isGift ? this.giftCartValue : this.cartValue;
    },
    getSearchProductsPlaceholder() {
      return this.$t("message.SearchProducts");
    },
  },

  updated() {
    this.doScroll();
  },
  mounted() {
    this.updateSelected(this.categories[0]);
    let odata = null;
    if (this.currentStoreDoc)
      odata = localStorage.getItem(this.currentStoreDoc.ID + "-OrdersDatas");
    this.OrdersData = odata != null ? JSON.parse(odata) : [];
    if (!this.OrdersData.length > 0 || !this.viewConfig.LogIn)
      this.hideReorder();
  },
  methods: {
    ...mapMutations([
      "setCurrentLocale",
      "setShowDeliveryFee",
      "setAllergySelected",
      "setIntoleranceSelected",
      "setPreferenceSelected",
    ]),
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    taphandler() {
      var now = new Date().getTime();

      var timesince = now - this.mylatesttap;
      if (timesince < 500 && timesince > 0) {
        event.preventDefault();
      }
      this.mylatesttap = new Date().getTime();
    },
    scrollToHere() {
      this.$emit("filterText", this.filterText);
    },
    hideReorder() {
      localStorage.removeItem(this.currentStoreDoc.ID + "-OrdersDatas");
      this.ReorderStatus = false;
      this.$emit("show-reorder", this.ReorderStatus);
    },
    hClick() {
      this.showDrawer = true;
    },
    navigateToShoppingCart() {
      this.setShowDeliveryFee(false);
      if (this.storeSelectionAtCheckoutMode) {
        this.$router.push({
          name: "mainpage",
          query: {
            selectMode: true,
          },
        });
      } else {
        this.$router.push({
          name: "shoppingcartmobile",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      }
    },
    scrollTo(element, to, duration) {
      var start = element.scrollTop,
        change = to - start,
        increment = 20;
      var that = this;
      var animateScroll = function(elapsedTime) {
        elapsedTime += increment;
        var position = that.easeInOut(elapsedTime, start, change, duration);
        element.scrollTop = position;
        if (elapsedTime < duration) {
          setTimeout(function() {
            animateScroll(elapsedTime);
          }, increment);
        } else {
          localStorage.setItem("animating", false);
        }
      };

      animateScroll(0);
    },
    easeInOut(currentTime, start, change, duration) {
      currentTime /= duration / 2;
      if (currentTime < 1) {
        return (change / 2) * currentTime * currentTime + start;
      }
      currentTime -= 1;
      return (-change / 2) * (currentTime * (currentTime - 2) - 1) + start;
    },
    doScroll() {
      if (this.once) {
        this.once = false;
        var that = this;
        //icon-menu height

        var previousIndex = -2;
        var currentIndex = -1;

        localStorage.setItem("animating", false);
        $$(".store-menu-mobile>li>a").on("click", function(event) {
          $$(".store-menu-mobile li").removeClass("active");

          // Make sure this.hash has a value before overriding default behavior
          if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();
            $$(this)
              .parent()
              .addClass("active");
            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            localStorage.setItem("animating", true);
            var scrollto =
              $$(hash).offset().top -
              $$("#section-" + that.categories[0].ID).offset().top +
              (that.showPopular ? 258 : 0);
            if (
              that.$root &&
              that.$root.$refs &&
              that.$root.$refs.Productlist &&
              that.$root.$refs.Productlist.$refs &&
              that.$root.$refs.Productlist.$refs.scrollview
            ) {
              that.scrollTo(
                that.$root.$refs.Productlist.$refs.scrollview,
                scrollto,
                300
              );
            }
          } // End if
        });
        var links = $$(".store-menu-mobile a");
        var sections = links.toArray().map((i) => {
          return i.hash;
        });
        // Setup a timer
        var timeout;
        // Listen for scroll events
        if (
          that.$root &&
          that.$root.$refs &&
          that.$root.$refs.Productlist &&
          that.$root.$refs.Productlist.$refs &&
          that.$root.$refs.Productlist.$refs.scrollview
        ) {
          that.$root.$refs.Productlist.$refs.scrollview.addEventListener(
            "scroll",
            function() {
              if (localStorage.getItem("animating") == "false") {
                // If there's a timer, cancel it
                if (timeout) {
                  window.cancelAnimationFrame(timeout);
                }
                // Setup the new requestAnimationFrame()
                timeout = window.requestAnimationFrame(function() {
                  // Run our scroll functions
                  var scrollTop = $(window).scrollTop();

                  for (let index = sections.length - 1; index >= 0; index--) {
                    const element = sections[index];
                    if (
                      $$(element).offset() &&
                      scrollTop >=
                        $$(element).offset().top -
                          (171 +
                            (!that.showPopular && that.ReorderStatus ? 166 : 0))
                    ) {
                      previousIndex = currentIndex;
                      currentIndex = index;
                      if (previousIndex != currentIndex) {
                        var id = $$(element).attr("id");
                        links.parent().removeClass("active");
                        var current = links.filter("[href*='#" + id + "']");
                        current.parent().addClass("active");
                        if (id != "section-search") {
                          current.parent().trigger("click");
                        } else {
                          that.updateSelected({ ID: "search" });
                        }
                        var menu = $$(".store-menu-mobile");
                        if (currentIndex % 2 == 0) {
                          $$(menu).animate(
                            {
                              scrollLeft:
                                $$(menu).scrollLeft() +
                                $$(current)
                                  .parent()
                                  .offset().left -
                                100,
                            },
                            100
                          );
                        }
                      }
                      break;
                    }
                  }
                });
              }
            },
            false
          );
        }
      }
    },
    updateSelected(category) {
      this.selected = category;
    },
    itemStyle(category) {
      var style = [];
      if (this.selected && category && this.selected.ID == category.ID) {
        style.push(this.mobileStyles.MenuHighlightedText);
        style.push(this.mobileStyles.MenuHighlight);
      } else {
        style.push(this.mobileStyles.CommonColorTxt);
      }
      return style;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      Validator.localize(locale, locale == "en" ? en : zh_CN);
      this.setCurrentLocale(locale);
    },
    showLogoError() {
      this.showLogo = false;
    },
    navigateToHome() {
      var url = this.getMobileEmbededReturnUrl;
      if (url) {
        window.location = url;
      }
    },
    openDietary() {
      this.showDietary = !this.showDietary;
    },
    allergyChecked(dietary) {
      if (this.getDietarySelection.Allergy.some((s) => s.Id == dietary.Id)) {
        this.setAllergySelected(
          this.getDietarySelection.Allergy.filter((s) => s.Id != dietary.Id)
        );
      } else {
        this.setAllergySelected([...this.getDietarySelection.Allergy, dietary]);
      }
    },
    intoleranceChecked(intolerance) {
      if (
        this.getDietarySelection.Intolerance.some((s) => s.Id == intolerance.Id)
      ) {
        this.setIntoleranceSelected(
          this.getDietarySelection.Intolerance.filter(
            (s) => s.Id != intolerance.Id
          )
        );
      } else {
        this.setIntoleranceSelected([
          ...this.getDietarySelection.Intolerance,
          intolerance,
        ]);
      }
    },
    preferencesChecked(preferences) {
      if (
        this.getDietarySelection.Preference.some((s) => s.Id == preferences.Id)
      ) {
        this.setPreferenceSelected(
          this.getDietarySelection.Preference.filter(
            (s) => s.Id != preferences.Id
          )
        );
      } else {
        this.setPreferenceSelected([
          ...this.getDietarySelection.Preference,
          preferences,
        ]);
      }
    },
    clearAllDietarySelection() {
      this.setAllergySelected([]);
      this.setIntoleranceSelected([]);
      this.setPreferenceSelected([]);
    },
    getStyle() {
      var style = [];
      if (this.value) {
        style.push(this.mobileStyles.CommonColorBackground);
      } else {
        style.push(this.mobileStyles.pendingStatusBackground);
      }
      return style;
    },
    getIconStyle(item) {
      if (item && item.Name)
        return [
          {
            "background-image": `url(https://abacus-assets.firebaseapp.com/onlineordering/images/dietary/icon/abacus_dietary_${item.Name.split(
              " "
            ).join("")}.png)`,
          },
        ];
      else return [];
    },
  },
};
</script>
<style scoped>
.language {
  margin-left: 10px;
}
.oo-module .mobile-wrapper .lg-dropdown-menu:after {
  right: 12% !important;
}
</style>
